"use client";

import { useEffect } from "react";
import IndustriesGrid from "@/components/industries-grid";
import Footer from "@/components/footer";

export default function IndustriesClient() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="flex min-h-screen flex-col">
      {/* Header + Grid */}
      <section className="flex-1 mx-auto max-w-[1200px] px-[3%] lg:px-[5%] py-6 md:py-12">
        <header className="text-center">
          {/* smaller on mobile, same big on desktop */}
          <h1 className="text-pretty text-[18px] sm:text-[20px] md:text-5xl font-semibold tracking-tight text-foreground">
            Industries We Serve
          </h1>
          <div
            className="mx-auto mt-2 md:mt-4 h-[3px] w-16 rounded-full"
            style={{ background: "var(--brand-yellow)" }}
            aria-hidden
          />
          {/* removed the paragraph per request */}
        </header>

        <div className="mt-6 md:mt-12">
          <IndustriesGrid />
        </div>
      </section>

      <Footer />
    </main>
  );
}
